import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Profile from '../views/Profile.vue'
import ResetPassword from '../views/ResetPassword.vue'
import SendResetPasswordMail from '../views/SendResetPasswordMail.vue'
import store from '../store/index'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/wachtwoord-vergeten',
    name: 'Wachtwoord Vergeten',
    component: SendResetPasswordMail
  },
  {
    path: '/wachtwoord-herstellen',
    name: 'Wachtwoord Herstellen',
    component: ResetPassword
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (process.env.NODE_ENV !== 'production') {
    store.dispatch("setUser", { id: "16", email: "daan@webdimensie.nl", role: "leverancier" })
    if (to.name !== 'Login' && to.name !== 'Wachtwoord Vergeten' && to.name !== 'Wachtwoord Herstellen' && !store.state.user.id) next({ name: 'Login' })
    else if (to.name === 'Login' && store.state.user.id) next({ name: 'Home' })
    else next()

    store.dispatch("fillSuppliersIfEmpty");
  } else {
    await store.dispatch("isAuthenticated")
    if (to.name !== 'Login' && to.name !== 'Wachtwoord Vergeten' && to.name !== 'Wachtwoord Herstellen' && !store.state.user.id) next({ name: 'Login' })
    else if (to.name === 'Login' && store.state.user.id) next({ name: 'Home' })
    else next()
  }
})

export default router
